import { batyr } from './batyr.ts';
import { bek } from './bek.ts';
import { gryd } from './gryd.ts';
import { kipchak } from './kipchak.ts';
import { druzhynnyk } from './druzhynnyk.ts';
import { striletz } from './striletz.ts';
import { varangian } from './varangian.ts';
import { UnitJsonConfig } from '@/core/types/battle.types';


export const RUTHENIAN_UNITS_DATA = {
    gryd,
    druzhynnyk,
    striletz,
    varangian,
} as const;

export const CUMANS_UNITS_DATA = {
    batyr,
    bek,
    kipchak,
} as const;


export type RuthenianUnitId = keyof typeof RUTHENIAN_UNITS_DATA;
export type CumanUnitId = keyof typeof CUMANS_UNITS_DATA;
export type UnitId = RuthenianUnitId | CumanUnitId;

export const UNITS_DATA: Record<UnitId, UnitJsonConfig> = {
    ...RUTHENIAN_UNITS_DATA,
    ...CUMANS_UNITS_DATA,
};